import Component from '@glimmer/component';
import { service } from '@ember/service';
import WebVersion from 'donor-elf-web/services/web-version';
import { action } from '@ember/object';

export default class NewWebVersionComponent extends Component {
  @service declare webVersion: WebVersion;

  @action
  handleRefresh() {
    location.reload();
  }
}
